import * as React from 'react';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import AppBar from '../components/AppBar';
import Toolbar from '../components/Toolbar';
import Typography from '../components/Typography';
import { API_BASE_URL, API_USERNAME_PATH } from '../../consts';
import refreshAccessToken from '../../modules/tools/refreshAccessToken';
import axios, { AxiosResponse } from 'axios'
import { Link as RouterLink } from 'react-router-dom'
import { styled } from '@mui/material/styles';
import { UI_SELF_SERVICE } from '../../consts';
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const rightLink = {
  fontSize: 20,
  color: 'common.white',
  ml: 3,
  marginLeft: '13px'
};

// interface ApiResponse {
//   status: number | null;
//   username: string | null;
// }

const NoUnderlineLink = styled(RouterLink)({
  textDecoration: 'none', // Remove the underline
  color: 'black', // Set the link color
});


// TODO: refactor (it is redundant; also the username path is called twice)
function AppAppBar() {

  // TODO confirm (start)
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);
  // TODO confirm (end)

  // const [apiResponse, setApiResponse] = React.useState<ApiResponse>({ status: null, username: null });

  // React.useEffect(() => {
  //   const fetchUserData = (accessToken: string | null): Promise<ApiResponse> => {
  //     return axios.get<ApiResponse>(
  //       `${API_BASE_URL}${API_USERNAME_PATH}`,
  //       {
  //         headers: { 'Authorization': `Bearer ${accessToken}` }
  //       }
  //     ).then((response: AxiosResponse<ApiResponse>) => {
  //       return {
  //         status: response.status,
  //         username: response.data.username
  //         // Add other fields as needed
  //       };
  //     });
  //   };

  //   const handleRefreshAndFetch = () => {
  //     refreshAccessToken()
  //       .then((accessRefreshed: string) => {
  //         return fetchUserData(accessRefreshed);
  //       })
  //       .then(response => {
  //         setApiResponse({ status: response.status, username: response.username });
  //       })
  //       .catch(error => {
  //         if (error.response && error.response.status === 401) {
  //           setApiResponse({ status: 401, username: null });
  //         } else {
  //           setApiResponse({ status: error.response && error.response.status ? error.response.status : 500, username: null });
  //         }
  //       });
  //   };

  //   const access = localStorage.getItem('access_token');
  //   // Make the API request when the component mounts

  //   fetchUserData(access)
  //     .then(response => {
  //       setApiResponse({ status: response.status, username: response.username });
  //     })
  //     .catch(error => {
  //       if (error.response && error.response.status === 401) {
  //         handleRefreshAndFetch();
  //       } else {
  //         setApiResponse({ status: error.response && error.response.status ? error.response.status : 500, username: null });
  //       }
  //     });

  // }, []);

  // const renderUsernameOrLinks = () => {
  //   if (apiResponse.status === 200 && apiResponse.username) {
  //     return (
  //       <Typography variant="h5" sx={rightLink}>
  //         <NoUnderlineLink to={UI_SELF_SERVICE}>
  //           {apiResponse.username}
  //         </NoUnderlineLink>
  //       </Typography>
  //     );
  //   } else {
  //     return (
  //       <>
  //         <Link
  //           color="inherit"
  //           variant="h5"
  //           underline="hover"
  //           href="/sign-up/"
  //           sx={{ ...rightLink, color: 'black' }}
  //         >
  //           {'Sign-Up'}
  //         </Link>
  //         <Link
  //           color="inherit"
  //           variant="h5"
  //           underline="hover"
  //           href="/sign-in/"
  //           sx={{ ...rightLink, color: 'black' }}
  //         >
  //           {'Sign-In'}
  //         </Link>
  //       </>
  //     );
  //   }
  // };

  return (
    <div>
      <AppBar position="fixed">
        <Toolbar sx={{ justifyContent: 'center', bgcolor: 'white', borderBottom: 1, borderColor: '#cfd8dc' }}>
          {/* <Box sx={{ flex: 1 }} /> */}
          <Link
            variant="h5"
            underline="none"
            color="#212121"
            href="/"
            sx={{ fontSize: 20 }}
          >
            {'外資系戦略コンサルに学ぶプレゼンテーションスキルの理論と実践'}
          </Link>
          {/* <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
            {renderUsernameOrLinks()}
          </Box> */}
        </Toolbar>
      </AppBar>
      <Toolbar />
    </div>
  );
}

// if we do not need user shown func
// function AppAppBar() {
//   return (
//     <div>
//       <AppBar position="fixed">
//         <Toolbar sx={{ justifyContent: 'space-between', bgcolor: 'white', borderBottom: 1, borderColor: '#cfd8dc' }}>
//           <Box sx={{ flex: 1 }} />
//           <Link
//             variant="h6"
//             underline="none"
//             color="#212121"
//             href="/"
//             sx={{ fontSize: 24 }}
//           >
//             {'Digital Art: Her'}
//           </Link>
//           <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
//             <Link
//               color="inherit"
//               variant="h5"
//               underline="hover"
//               href="/sign-up/"
//               sx={{ ...rightLink, color: 'black' }}
//             >
//               {'Sign-Up'}
//             </Link>
//             <Link
//               color="inherit"
//               variant="h5"
//               underline="hover"
//               href="/sign-in/"
//               sx={{ ...rightLink, color: 'black' }}
//             >
//               {'Sign-In'}
//             </Link>
//           </Box>
//         </Toolbar>
//       </AppBar>
//       <Toolbar />
//     </div >
//   );
// }

export default AppAppBar;

// the following is kinda broken ver but just in case to save
{/* <AppBar position="fixed">
        <Toolbar sx={{ justifyContent: 'space-between', bgcolor: 'white', borderBottom: 1, borderColor: '#cfd8dc' }}>
          <Box sx={{ flex: 1 }} />
          <Link
            variant="h6"
            underline="none"
            color="#212121"
            href="/"
            sx={{ fontSize: 24 }}
          >
            {'Digital Art: Her'}
          </Link>
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', gap: '5px' }}>
            <Box sx={{ border: 1, borderColor: 'white', borderRadius: '10px', width: '15%' }} >
              <Typography align='center'>
                <Link
                  color="inherit"
                  variant="h5"
                  underline="hover"
                  href="/sign-in/"
                  sx={{ color: 'black' }}
                >
                  {'SIGN IN'}
                </Link>
              </Typography>
            </Box>
            <Box sx={{ border: 1, borderColor: 'white', borderRadius: '10px', width: '15%' }} >
              <Typography align='center'>
                <Link
                  color="inherit"
                  variant="h5"
                  underline="hover"
                  href="/sign-up/"
                  sx={{ color: 'black' }}
                >
                  {'SIGN UP'}
                </Link>
              </Typography>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar /> */}
